import Axios from 'axios';
var AccountService = (function () {
    function AccountService() {
    }
    AccountService.prototype.getAccountInfo = function () {
        return Axios.get('supplierapi/center/info');
    };
    AccountService.prototype.getAccountInfoByToken = function (params) {
        return Axios.get('supplierclientapi/get_info_by_token', { params: params });
    };
    AccountService.prototype.updateAccountInfo = function (params) {
        return Axios.post('supplierapi/center/modify_info', params);
    };
    AccountService.prototype.getEvaluateDetail = function () {
        return Axios.get('supplierapi/center/evaluate_detail');
    };
    AccountService.prototype.getTaskList = function () {
        return Axios.get('supplierapi/center/task_list');
    };
    AccountService.prototype.certification = function (params) {
        return Axios.post('supplierapi/center/certification', params);
    };
    AccountService.prototype.sign = function (params) {
        return Axios.post('supplierapi/center/sign', params);
    };
    AccountService.prototype.getActivityList = function () {
        return Axios.get('supplierapi/center/activity_list');
    };
    AccountService.prototype.joinActivity = function (params) {
        return Axios.post('supplierapi/center/join_activity', params);
    };
    AccountService.prototype.getPrivilege = function () {
        return Axios.get('supplierapi/center/privilege');
    };
    AccountService.prototype.getPointLog = function (params) {
        return Axios.get('supplierapi/center/point_log', { params: params });
    };
    AccountService.prototype.getCouponList = function (params) {
        return Axios.get('supplierapi/center/coupon_list', { params: params });
    };
    AccountService.prototype.getinviteInfo = function (params) {
        return Axios.get('supplierclientapi/shopping/invite_business', { params: params });
    };
    AccountService.prototype.getShareInfo = function (params) {
        return Axios.get('supplierapi/center/share_info', { params: params });
    };
    AccountService.createInstance = function () {
        AccountService.getInstance();
    };
    AccountService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return AccountService;
}());
export default AccountService;
